<!--
 * @Author: xiaokun
 * @Date: 2020-04-12 22:13:32
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-23 16:10:04
 * @Description: 试卷审批
 -->
<template>
  <div
    class="paper-examine-approve"
  >
    <create-header
      v-if="isPaperExamineApprove"
      :title="'考试审批'"
      :need-back-txt="false"
    />
    <div class="paper-examine-approve-content">
      <!-- 试卷基本信息 -->
      <paper-info
        :paper-id="paperId"
        @getPeopleNum="getPeopleNum"
      />
      <!-- 审批/未审批切换 -->
      <div class="change-box">
        <mk-radio-group
          v-model="curContent"
          @change="changeCurContent"
        >
          <mk-radio-button label="unExamine">
            未审批 ( {{ notApprovalNum }} )
          </mk-radio-button>
          <mk-radio-button label="alreadyExamine">
            已审批 ( {{ alreadyApprovalNum }} )
          </mk-radio-button>
        </mk-radio-group>
      </div>
      <!-- 表格数据 -->
      <examine-approve-table
        ref="examineApproveTable"
        :is-paper-examine-approve="isPaperExamineApprove"
        :paper-id="paperId"
      />
    </div>
  </div>
</template>
<script>
import createHeader from '@components/create-header'
import PaperInfo from './paper-info'
import ExamineApproveTable from './examine-approve-table'
export default {
  name: 'PaperExamineApprove',
  components: { PaperInfo, ExamineApproveTable, createHeader },
  props: {
    // 是否展示头部 返回 如果 不展示 则为学习任务跳来的审批列表 不展示关联任务筛选
    isPaperExamineApprove: {
      type: Boolean,
      default: true
    },
    // paperId
    paperId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      curContent: 'unExamine',
      // 未审数
      notApprovalNum: 0,
      // 已审核数
      alreadyApprovalNum: 0
    }
  },
  watch: {},
  created () {},
  mounted () {},
  deactivated () {
    this.$destroy()
  },
  methods: {
    // 切换当前选中审批状态
    changeCurContent (val) {
      this.$refs.examineApproveTable.changeCurContent(val)
    },
    getPeopleNum (a, b) {
      this.notApprovalNum = a
      this.alreadyApprovalNum = b
    }
  }
}
</script>
<style lang='scss' scoped>
.paper-examine-approve {
  display: flex;
  flex-direction: column;
  height: 100%;
  // margin: 0 auto;
  position: relative;

  /deep/ .el-table__row {
    .el-button--text {
      font-size: 13px;
    }
  }

  .paper-examine-approve-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
    height: 0;
    // overflow-y: scroll;

    .change-box {
      padding: 30px 0 20px;

      /deep/ .el-radio-button__inner {
        padding: 8px 15px;
      }
    }
  }
}
</style>
